<script lang="ts" setup>
  import { useTheme } from 'vuetify'

  import { useAppStore } from '#ourahub-intra/stores/application'

  import type { OuraUser } from '#web-oura-tools/types/user'

  const props = defineProps<{
    loading: boolean

    user: OuraUser | undefined | null
  }>()

  const theme = useTheme()

  const ouraHubStore = useAppStore()

  function toggleChat(showChat: boolean) {
    ouraHubStore.updateAccountPrefs({ showChat })
  }

  function changeTheme(themeName: 'dark' | 'light' | 'system') {
    ouraHubStore.updateAccountPrefs({ theme: themeName })
  }
</script>

<template language="html">
  <v-menu offset="8" width="320" location="bottom" transition="scale-transition" :close-on-content-click="false">
    <template #activator="{ props: menuProps }">
      <o-btn-text v-bind="menuProps" icon>
        <v-icon icon="mdi-cog" />
      </o-btn-text>
    </template>

    <v-list class="bg-primary">
      <v-list-subheader title="Theme" />

      <o-btn-toggle
        variant="outlined"
        class="d-flex my-2 mx-4"
        :loading="props.loading"
        :model-value="theme.isSystem.value ? 'system' : theme.global.name.value"
        @update:model-value="changeTheme($event as 'dark' | 'light' | 'system')"
      >
        <v-btn value="light" class="flex-grow-1" icon="mdi-weather-sunny" />
        <v-btn value="dark" class="flex-grow-1" icon="mdi-weather-night" />
        <v-btn value="system" icon="mdi-laptop" class="flex-grow-1" />
      </o-btn-toggle>

      <v-list-subheader class="mt-4" title="Features" />

      <v-switch
        hide-details
        class="mx-4"
        label="Show Glean chat in OuraHub"
        :loading="props.loading"
        :model-value="ouraHubStore.accountPrefs?.showChat !== false"
        @update:model-value="toggleChat($event ?? false)"
      />
    </v-list>
  </v-menu>
</template>
